var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container container-narrow" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("title.company_codes") } }),
        _vm.emptyPage ||
        (!_vm.errorPage && Array.isArray(_vm.codes) && _vm.codes.length === 0)
          ? _c("article", { staticClass: "message is-warning" }, [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("codes.empty"))),
              ]),
            ])
          : _vm.errorPage
          ? _c("article", { staticClass: "message is-danger" }, [
              _c("div", { staticClass: "message-body" }, [
                _vm._v(_vm._s(_vm.$t("alert.error"))),
              ]),
            ])
          : _vm._e(),
        _vm.refreshing
          ? _c("hourglass")
          : _vm._l(_vm.codes, function (code) {
              return _c(
                "div",
                { key: code.code, staticClass: "margin-top-md" },
                [
                  _c("article", { staticClass: "message invite-code-block" }, [
                    _c("div", { staticClass: "message-body code-body" }, [
                      _c(
                        "div",
                        { staticClass: "columns is-centered is-mobile" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "column is-narrow is-centered is-vcentered code-column",
                            },
                            [
                              _c(
                                "strong",
                                { staticClass: "is-size-4-desktop" },
                                [_vm._v(_vm._s(code.code))]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "column is-vcentered" }, [
                            _c("div", { staticClass: "is-size-5-desktop" }, [
                              _c("p"),
                              _c("div", { staticClass: "dot-circle" }),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("codes.received_on", {
                                    date: _vm.getDate(code.timestamp, true),
                                  })
                                )
                              ),
                              _c("p"),
                              _c("p"),
                              _c("div", { staticClass: "dot-circle" }),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("codes.expires_on", {
                                    date: _vm.getDate(code.expiration, true),
                                  })
                                )
                              ),
                              _c("p"),
                              _c("p"),
                              _c("div", { staticClass: "dot-circle" }),
                              _vm._v(
                                _vm._s(
                                  code.users && code.users.length > 0
                                    ? _vm.$t("codes.valid_for_usage", {
                                        max: code.limit,
                                        current: code.users.length,
                                      })
                                    : _vm.$t("codes.valid_for", {
                                        max: code.limit,
                                      })
                                )
                              ),
                              _c("p"),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _c("code-messages-comp", { attrs: { code: code } }),
                ],
                1
              )
            }),
        !_vm.refreshing
          ? _c("div", { staticClass: "margin-top-md has-text-centered" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary button-right-icon",
                  attrs: { type: "button" },
                  on: { click: _vm.resetAndLoad },
                },
                [
                  _vm._v(_vm._s(_vm.$t("button.update"))),
                  _c(
                    "span",
                    { staticClass: "icon feather" },
                    [_c("refresh-cw-icon")],
                    1
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }